import { I18n } from 'i18n-js'
import translations from '../locales.json'

const i18n = new I18n(translations)

export function setupI18n(locale) {
  i18n.locale = locale
  return i18n
}
